<template>
  <div class="wel_bg">
    <div></div>
    <div class="top_flex"
         v-show="!roleObj.showPrintChart && roleObj.showNormalChart">
      <div class="top_one top_margin"
           @click="jump(1)">
        <div class="top_number">{{ topObj.todayOrderNum }}</div>
        <div class="top_font">今日跟踪回访总数</div>
      </div>
      <div class="top_two top_margin"
           @click="jump(2)">
        <div class="top_number">{{ topObj.todayDeliverNum }}</div>
        <div class="top_font">今日档案总数</div>
      </div>
      <div class="top_five top_margin"
           @click="jump(3)">
        <div class="top_number">{{ topObj.totalNotDeliverNum  }}</div>
        <div class="top_font">未跟踪总数</div>
      </div>
      <div class="top_three top_margin"
           @click="jump(4)">
        <div class="top_number">{{ topObj.thirtyDayOrderNum }}</div>
        <div class="top_font">
          近30天跟踪回访总数
        </div>
      </div>
      <div class="top_four top_margin"
           @click="jump(5)">
        <div class="top_number">{{ topObj.totalOrderNum }}</div>
        <div class="top_font">
          {{ userInfo.tenantId == "000000" ? "平台" : "" }}总跟踪回访量
        </div>
      </div>
    </div>
    <div class="center_flex"
         v-show="!roleObj.showPrintChart && roleObj.showNormalChart">
      <div class="center_flex1">
        <div class="wares_search">
          <div class="title">商户档案</div>
          <div class="sh_div"
               v-if="userInfo.tenantId == '000000'">
            <el-select v-model="sh.id"
                       name="merchantName"
                       value-key="id"
                       placeholder="请选择"
                       @change="changeSh">
              <el-option v-for="item in sh.options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="block">
            <el-date-picker v-model="barTime"
                            size="large"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            value-format="yyyy-MM-dd"
                            @change="changeTime">
            </el-date-picker>
          </div>
        </div>
        <div id="Echart1"></div>
      </div>
      <div class="center_flex1">
        <div id="Echart2"></div>
      </div>
    </div>
    <div class="bottom_flex_div"
         v-show="!roleObj.showPrintChart && roleObj.showNormalChart">
      <div class="bottom_flex">
        <div id="bottom1"></div>
      </div>
      <div class="bottom_flex">
        <div id="bottom2"></div>
      </div>
      <div class="bottom_flex">
        <div id="bottom3"></div>
      </div>
      <div class="bottom_flex">
        <div id="bottom4"></div>
      </div>
      <div class="bottom_flex">
        <div id="bottom5"></div>
      </div>
    </div>
    <div class="ysc_flex"
         v-show="roleObj.showPrintChart">
      <div class="bottom_flex">
        <div id="bottom6"></div>
      </div>
      <div class="bottom_flex">
        <div id="bottom7"></div>
      </div>
    </div>
    <div class="bottom">
      <span>Copyright © 2012-2023 公益项目信息化管理系统</span>
      <el-divider direction="vertical" />
      <span>技术支持</span>
      <el-divider direction="vertical" />
      <span>
        <el-link href="https://www.vstimevms.com"
                 target="_blank">微时刻</el-link>
      </span>
      <el-divider direction="vertical" />
      <span>备案/许可证编号：</span>
      <span>
        <el-link href="https://beian.miit.gov.cn"
                 target="_blank">闽ICP备15007253号</el-link>
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  summuryTop,
  summaryCarry,
  summaryCashGoods,
  summuryBottom,
  queryHomeMerchantList,
  getUserRole,
} from "@/api/echarts/echarts.js";

export default {
  name: "wel",
  data () {
    return {
      topObj: {},
      sh: {
        id: "",
        options: [],
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      barTime: "",
      roleIndex: 1,
      roleObj: {},
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  created () { },
  mounted () {
    this.getData();
  },
  methods: {
    jump (index) {
      this.$router.push({ path: '/order', query: { id: index } })
    },
    takeEchartsBar (xData, sData1, sData2) {
      var myChart = this.$echarts.init(document.getElementById("Echart1"));
      var option = {
        color: ["#C1CCFF", "#4264FF"],
        grid: {
          top: "9%",
          bottom: "10%",
          left: "9%",
          right: "5%",
        },
        dataZoom: {
          type: "inside",
          start: 0,
          end: xData.length > 6 ? (5 / xData.length) * 100 : 100,
          zoomLock: true,
        },
        tooltip: {
          // show: true,
          // axisPointer: {
          //   type: "shadow",
          // },
          trigger: "axis",
        },
        legend: {
          top: 0,
          right: "5%",
          data: ["档案量", "回访量"],
        },
        xAxis: {
          axisTick: false,
          type: "category",
          axisLine: {
            show: true,
            lineStyle: {
              color: "#EEEEEE",
            },
          },
          axisLabel: {
            color: "#353941",
            fontFamily: "PingFang-SC-Regular, PingFang-SC;",
            fontSize: 15 * this.$htmlSize,
          },
          data: xData,
        },
        yAxis: {
          show: true,
          type: "value",
          axisLine: {
            show: true,
            lineStyle: {
              color: "#EEEEEE",
            },
          },
          axisLabel: {
            color: "#353941",
            fontFamily: "PingFang-SC-Regular, PingFang-SC",
            fontSize: 15 * this.$htmlSize,
          },
        },
        series: [
          // {
          //   name: "档案量",
          //   data: sData1,
          //   type: "bar",
          //   stack: "Ad",
          //   smooth: true,
          //   barWidth: 37 * this.$htmlSize,
          //   label: {
          //     show: true,
          //     width: 20,
          //     overflow: "break",
          //     fontSize: 20,
          //     fontWeight: "bold",
          //     color: "rgb(255,255,255)",
          //     fontFamily: "DINPro-Regular",
          //   },
          // },
          {
            name: "档案量",
            type: 'bar',
            barGap: '-100%',
            barWidth: 37 * this.$htmlSize,
            // itemStyle: {
            //   normal: {
            //     color: new this.$echarts.graphic.LinearGradient(
            //       0, 0, 0, 1,
            //       [
            //         { offset: 0, color: 'rgba(20,200,212,0.5)' },
            //         { offset: 0.2, color: 'rgba(20,200,212,0.2)' },
            //         { offset: 1, color: 'rgba(20,200,212,0)' }
            //       ]
            //     )
            //   }
            // },
            label: {
              show: true,
              width: 20,
              overflow: "break",
              fontSize: 20,
              fontWeight: "bold",
              color: "#fba613",
              fontFamily: "DINPro-Regular",
              position: 'insideTop'
            },
            z: -12,
            data: sData1
          },
          {
            name: "回访量",
            data: sData2,
            type: "bar",
            stack: "Ad",
            smooth: true,
            barWidth: 37 * this.$htmlSize,
            label: {
              show: true,
              fontSize: 20,
              width: 20,
              overflow: "break",
              fontWeight: "bold",
              color: "rgb(255,255,255)",
              fontFamily: "DINPro-Regular",
            },
          },
        ],
      };
      myChart.setOption(option, true);
      var _this = this;
      window.addEventListener("resize", function () {
        _this.$htmlSize =
          (document.documentElement.clientWidth || document.body.clientWidth) /
          1920;
        option.xAxis.axisLabel.fontSize = 15 * _this.$htmlSize;
        option.yAxis.axisLabel.fontSize = 15 * _this.$htmlSize;
        option.series[0].barWidth = 37 * _this.$htmlSize;
        option.series[1].barWidth = 37 * _this.$htmlSize;
        myChart.setOption(option, true);
        myChart.resize();
      });
    },
    takeEchartLine (xData, sData) {
      var _this = this;
      var myChart = this.$echarts.init(document.getElementById("Echart2"));
      var option = {
        color: ["#7429FF"],
        title: {
          text: "档案量/(天)",
          textStyle: {
            fontWeight: "bold",
            fontFamily: "PingFang-SC-Bold, PingFang-SC",
            color: "#353941",
            fontSize: 22,
          },
          left: 26,
          top: 28,
        },
        grid: {
          top: "24%",
          bottom: "10%",
          left: "9%",
          right: "5%",
        },
        tooltip: {
          trigger: "axis",
        },
        dataZoom: {
          type: "inside",
          start: 80,
          end: 100,
          zoomLock: true,
          endValue: 50,
        },
        xAxis: {
          axisTick: false,
          type: "category",
          data: xData,
          axisLine: {
            show: true,
            lineStyle: {
              color: "#EEEEEE",
            },
          },
          axisLabel: {
            interval: 0,
            color: "#353941",
            fontFamily: "DINPro-Regular",
            fontSize: 15 * this.$htmlSize,
          },
        },
        yAxis: {
          show: true,
          type: "value",
          axisLine: {
            show: true,
            lineStyle: {
              color: "#EEEEEE",
            },
          },
          axisLabel: {
            color: "#353941",
            fontFamily: "DINPro-Regular",
            fontSize: 15 * this.$htmlSize,
          },
        },
        areaStyle: {
          normal: {
            //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
            color: new _this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: "rgba(80,141,255,0.39)",
              },
              {
                offset: 0.34,
                color: "rgba(56,155,255,0.25)",
              },
              {
                offset: 1,
                color: "rgba(38,197,254,0.00)",
              },
            ]),
          },
        },
        series: [
          {
            name: "档案量",
            type: "line",
            symbol: "none",
            smooth: true,
            barWidth: 37 * this.$htmlSize,
            areaStyle: {
              color: new _this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(116, 41, 255, .27)",
                },
                {
                  offset: 1,
                  color: "rgba(116, 41, 255, 0)",
                },
              ]),
              label: {
                show: true,
                fontWeight: "bold",
                color: "#353941",
                fontFamily: "DINPro-Regular",
              },
            },
            data: sData,
          },
        ],
      };
      myChart.setOption(option, true);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    takeEchartsPie (id, colors, title, sData) {
      let myChart = this.$echarts.init(document.getElementById(id));
      var legend, series;
      if (id == "bottom3") {
        let legendData = [];
        for (let i = 0; i < sData.length; i++) {
          legendData.push({
            name: sData[i].name,
            value: sData[i].value,
            itemStyle: {
              color: colors[i],
            },
          });
        }
        legend = [
          {
            show: true,
            selectedMode: false,
            icon: "rect",
            itemWidth: 4,
            itemHeight: 43,
            top: 68,
            left: "10%",
            orient: "vertical",
            itemGap: 17,
            formatter: (data) => {
              for (let i = 0; i < sData.length; i++) {
                if (sData[i].name == data) {
                  return (
                    "{a|" + sData[i].value + "}\n" + "{b|" + sData[i].name + "}"
                  );
                }
              }
            },
            textStyle: {
              rich: {
                a: {
                  fontSize: 23,
                  fontFamily: "DINPro-Bold, DINPro",
                  fontWeight: "bold",
                  color: "#353941",
                },
                b: {
                  fontSize: 13,
                  fontFamily: "PingFangSC-Regular, PingFang SC",
                  fontWeight: "400",
                  color: "#9FA1AA",
                  padding: [4, 0, 0, 0],
                },
              },
            },
            data: legendData,
          },
        ];
        series = [
          {
            type: "pie",
            legendHoverLink: false,
            emphasis: {
              scale: false,
            },
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            z: 3,
            center: ["65%", "55%"],
            radius: ["26%", "41%"],
            data: [
              {
                name: sData[0].name,
                value: sData[0].value,
                itemStyle: {
                  color: colors[0],
                  borderRadius: 20,
                },
              },
              {
                name: sData[1].name,
                value: sData[1].value,
                itemStyle: {
                  color: "rgba(252, 196, 44,0)",
                },
              },
              {
                name: sData[2].name,
                value: sData[2].value,
                itemStyle: {
                  color: "rgba(252, 196, 44,0)",
                },
              },
            ],
          },
          {
            type: "pie",
            legendHoverLink: false,
            emphasis: {
              scale: false,
            },
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            z: 2,
            center: ["65%", "55%"],
            radius: ["26%", "41%"],
            data: [
              {
                name: sData[1].name,
                value: sData[0].value + sData[1].value,
                itemStyle: {
                  color: colors[1],
                  borderRadius: 20,
                },
              },
              {
                name: sData[2].name,
                value: sData[2].value,
                itemStyle: {
                  color: "rgba(252, 196, 44,0)",
                  borderRadius: 20,
                },
              },
            ],
          },
          {
            type: "pie",
            legendHoverLink: false,
            emphasis: {
              scale: false,
            },
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            z: 1,
            center: ["65%", "55%"],
            radius: ["26%", "41%"],
            data: [
              {
                value: 1,
                itemStyle: {
                  color: colors[2],
                  borderRadius: 20,
                },
              },
            ],
          },
          {
            type: "pie",
            legendHoverLink: false,
            emphasis: {
              scale: false,
            },
            label: {
              show: true,
              formatter: "{d}%",
            },
            labelLine: {
              length: 10,
              length2: 0,
            },
            z: 0,
            center: ["65%", "55%"],
            radius: ["26%", "41%"],
            data: [
              {
                name: sData[0].name,
                value: sData[0].value,
                label: {
                  color: colors[0],
                },
              },
              {
                name: sData[1].name,
                value: sData[1].value,
                label: {
                  color: colors[1],
                },
              },
              {
                name: sData[2].name,
                value: sData[2].value,
                label: {
                  color: colors[2],
                },
              },
            ],
          },
        ];
      } else {
        legend = [
          {
            show: true,
            selectedMode: false,
            icon: "rect",
            itemWidth: 4,
            itemHeight: 43,
            top: 99,
            left: "10%",
            orient: "vertical",
            itemGap: 26,
            formatter: (data) => {
              for (let i = 0; i < sData.length; i++) {
                if (sData[i].name == data) {
                  return (
                    "{a|" + sData[i].value + "}\n" + "{b|" + sData[i].name + "}"
                  );
                }
              }
            },
            textStyle: {
              rich: {
                a: {
                  fontSize: 23,
                  fontFamily: "DINPro-Bold, DINPro",
                  fontWeight: "bold",
                  color: "#353941",
                },
                b: {
                  fontSize: 13,
                  fontFamily: "PingFangSC-Regular, PingFang SC",
                  fontWeight: "400",
                  color: "#9FA1AA",
                  padding: [4, 0, 0, 0],
                },
              },
            },
            data: sData,
          },
        ];
        series = [
          {
            type: "pie",
            legendHoverLink: false,
            emphasis: {
              scale: false,
            },
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            z: 0,
            center: ["65%", "55%"],
            radius: ["26%", "41%"],
            itemStyle: {
              color: colors[0],
            },
            data: [
              {
                value: 1,
              },
            ],
          },
          {
            type: "pie",
            color: colors,
            legendHoverLink: false,
            emphasis: {
              scale: false,
            },
            z: 1,
            label: {
              show: true,
              formatter: "{d}%",
            },
            labelLine: {
              length: 10,
              length2: 0,
            },
            center: ["65%", "55%"],
            radius: ["26%", "41%"],
            itemStyle: {
              borderRadius: 20,
            },
            data: sData,
          },
        ];
      }
      let option = {
        color: colors,
        title: {
          text: title,
          textStyle: {
            fontWeight: "bold",
            fontFamily: "PingFang-SC-Bold, PingFang-SC",
            color: "#353941",
            fontSize: 17,
          },
          left: 26,
          top: 26,
        },
        legend: legend,
        series: series,
      };
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
    takeEchartsPie1 (id, title, sData) {
      let myChart = this.$echarts.init(document.getElementById(id));
      let option = {
        title: {
          text: title,
          textStyle: {
            fontWeight: "bold",
            fontFamily: "PingFang-SC-Bold, PingFang-SC",
            color: "#353941",
            fontSize: 17,
          },
          left: 26,
          top: 26,
        },
        tooltip: {
          show: true,
          axisPointer: {
            type: "shadow",
          },
        },
        series: {
          type: "pie",
          legendHoverLink: true,
          // emphasis: {
          //   scale: false,
          // },
          label: {
            show: true,
            formatter: "{b}{d}%",
          },
          labelLine: {
            length: 20,
            length2: 10,
          },
          center: ["50%", "50%"],
          radius: ["0%", "40%"],
          data: sData,
        },
      };
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
    changeSh () {
      this.getSummaryCarry(this.sh.id, this.barTime[0], this.barTime[1]);
    },
    changeTime () {
      this.getSummaryCarry(this.sh.id, this.barTime ? this.barTime[0] : '', this.barTime ? this.barTime[1] : '');
    },
    getData () {
      getUserRole().then((res) => {
        this.roleObj = res.data.data;
        if (!this.roleObj.showPrintChart && !this.roleObj.showNormalChart) {
          this.$router.push("/printing");
        }
        if (!this.roleObj.showPrintChart) {
          // 顶部
          summuryTop().then((res) => {
            this.topObj = res.data.data;
          });
          // 获取商户,仅商户号为000000
          if (this.userInfo.tenantId == "000000") {
            queryHomeMerchantList().then((res) => {
              if (res.data.code == 200) {
                var data = [
                  {
                    label: "请选择",
                    value: "",
                  },
                ];
                var result = res.data.data;
                for (let i = 0; i < result.length; i++) {
                  data.push({
                    label: result[i].merchantName,
                    value: result[i].id,
                  });
                }
                this.sh.options = JSON.parse(JSON.stringify(data));
              }
            });
          }
          // 柱状图
          this.getSummaryCarry();
          // 折线图
          summaryCashGoods().then((res) => {
            if (res.data.code == 200) {
              var result = res.data.data;
              this.takeEchartLine(result.cashXData, result.cashYData);
            }
          });
        }
        var _this = this;
        setTimeout(() => {
          var Pie1sData = [];
          for (let i = 0; i < _this.roleObj.merchantData.length; i++) {
            Pie1sData.push({
              name: _this.roleObj.merchantData[i].merchantName,
              value: _this.roleObj.merchantData[i].num,
            });
          }
          this.takeEchartsPie1("bottom7", "各商户占比", Pie1sData);
        }, 1000);
        // 饼图
        summuryBottom().then((res) => {
          if (res.data.code == 200) {
            var result = res.data.data;

            this.takeEchartsPie(
              "bottom1",
              ["#FF7373", "#FFC639"],
              "卡印刷数量",
              [
                {
                  name: "发卡待印刷",
                  value: result.printData.waitPrintNum,
                  label: {
                    color: "#FF7373",
                  },
                },
                {
                  name: "发卡已印刷",
                  value: result.printData.printNum,
                  label: {
                    color: "#FFC639",
                  },
                },
              ]
            );

            this.takeEchartsPie(
              "bottom2",
              ["#7379FF", "#5BDBFF"],
              "卡激活数量",
              [
                {
                  name: "未激活",
                  value: result.activeData.waitActiveNum,
                  label: {
                    color: "#7379FF",
                  },
                },
                {
                  name: "已激活",
                  value: result.activeData.activeNum,
                  label: {
                    color: "#5BDBFF",
                  },
                },
              ]
            );
            this.takeEchartsPie(
              "bottom3",
              ["#1060E3", "#FF5E5E", "#FCC42C"],
              "领取数量",
              [
                {
                  name: "未领取",
                  value: result.cashData.waitCashNum,
                },
                {
                  name: "线上领取",
                  value: result.cashData.onNum,
                },
                {
                  name: "线下核销",
                  value: result.cashData.offNum,
                },
              ]
            );
            this.takeEchartsPie("bottom4", ["#04B86F", "#3F7C40"], "发货数量", [
              {
                name: "未发货",
                value: result.sendData.waitSendNum,
                label: {
                  color: "#04B86F",
                },
              },
              {
                name: "已发货",
                value: result.sendData.sendNum,
                label: {
                  color: "#3F7C40",
                },
              },
            ]);
            this.takeEchartsPie(
              "bottom5",
              ["#BE4681", "#FF7A7A "],
              "卡过期数量",
              [
                {
                  name: "已过期",
                  value: result.validData.unValidNum,
                  label: {
                    color: "#BE4681",
                  },
                },
                {
                  name: "未过期",
                  value: result.validData.validNum,
                  label: {
                    color: "#FF7A7A",
                  },
                },
              ]
            );
            this.takeEchartsPie(
              "bottom6",
              ["#FF7373", "#FFC639"],
              "卡印刷数量",
              [
                {
                  name: "发卡待印刷",
                  value: this.roleObj.printData.waitPrintNum,
                  label: {
                    color: "#FF7373",
                  },
                },
                {
                  name: "发卡已印刷",
                  value: this.roleObj.printData.printNum,
                  label: {
                    color: "#FFC639",
                  },
                },
              ]
            );
          }
        });
      });
    },
    getSummaryCarry (id, startDate, endDate) {
      summaryCarry({
        merchantId: id ? id : "",
        startDate: startDate ? startDate : "",
        endDate: endDate ? endDate : "",
      }).then((res) => {
        if (res.data.code == 200) {
          var result = res.data.data;
          this.takeEchartsBar(
            result.carryXData,
            result.cashData,
            result.sendData
          );
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wel_bg {
  min-height: 100%;
  box-sizing: border-box;
  padding: 35px;
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.el-divider--horizontal {
  margin: 12px 0 !important;
}
.top_flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.top_margin {
  margin-right: 7px;
}
.top_one {
  width: 307px;
  height: 144px;
  border-radius: 17px;
  background: url("../../assets/images/wel/top1.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding-left: 140px;
  padding-bottom: 20px;
  box-sizing: border-box;
  cursor: pointer;
}
.top_number {
  font-size: 44px;
  font-family: DINPro-Bold, DINPro;
  font-weight: bold;
  color: #ffffff;
  margin-bottom: 11px;
}
.top_font {
  font-size: 15px;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.8);
}
.top_two {
  width: 307px;
  height: 144px;
  border-radius: 17px;
  background: url("../../assets/images/wel/top2.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding-left: 140px;
  padding-bottom: 20px;
  box-sizing: border-box;
  cursor: pointer;
}
.top_five {
  width: 307px;
  height: 144px;
  border-radius: 17px;
  background: url("../../assets/images/wel/top5.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding-left: 140px;
  padding-bottom: 20px;
  box-sizing: border-box;
  cursor: pointer;
}
.top_three {
  width: 307px;
  height: 144px;
  border-radius: 17px;
  background: url("../../assets/images/wel/top3.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding-left: 140px;
  padding-bottom: 20px;
  box-sizing: border-box;
  cursor: pointer;
}
.top_four {
  width: 307px;
  height: 144px;
  border-radius: 17px;
  background: url("../../assets/images/wel/top4.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding-left: 140px;
  padding-bottom: 20px;
  box-sizing: border-box;
  cursor: pointer;
}

.el-font-size {
  font-size: 14px;
}
.home_center {
  height: 700px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 0;
}
.bottom {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  font-size: 14px;
  color: black;
  height: 60px;
}
.center_flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 19px 0;
}
.center_flex1 {
  flex: 1;
  height: 518px;
  background: #ffffff;
  border-radius: 17px;
  margin-right: 16px;
  display: flex;
  flex-direction: column;
}
.center_flex1:last-child {
  margin-right: 0;
}
#Echart1,
#Echart2 {
  width: 100%;
  flex: 1;
  display: flex;
}
.wares_search {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  padding-right: 5%;
  align-items: center;
  z-index: 1;
  box-sizing: border-box;
  padding-left: 26px;

  .title {
    height: 87px;
    line-height: 87px;
    font-size: 22px;
    font-family: PingFang-SC-Bold, PingFang-SC;
    font-weight: bold;
    color: #353941;
  }

  .sh_div {
    width: 166px;
    height: 35px;
    margin-left: 144px;
    z-index: -1;
  }
  .el-date-editor {
    width: 279px !important;
  }
  .block {
    width: 279px !important;
    height: 35px;
    margin-left: 13px;
    z-index: -1;
  }
}
.title_font {
  font-size: 22px;
  font-family: PingFang-SC-Bold, PingFang-SC;
  font-weight: bold;
  color: #353941;
}
.bottom_flex_div {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-between;
  margin: 19px 0;
  .bottom_flex {
    width: 305px;
    height: 276px;
    background: #ffffff;
    border-radius: 17px;
    margin-right: 16px;
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
    div {
      width: 100%;
      height: 100%;
    }
  }
  .bottom_flex:last-child {
    margin-right: 0 !important;
  }
}
.ysc_flex {
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: flex-start;
  .bottom_flex {
    width: 780px;
    height: 576px;
    background: #ffffff;
    border-radius: 17px;
    margin-right: 16px;
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
    div {
      width: 100%;
      height: 100%;
    }
  }
  .bottom_flex:last-child {
    margin-right: 0 !important;
  }
}
// @media screen and (min-width: 1800px) {
//   .bottom_flex:nth-child(5) {
//     margin-right: 0 !important;
//   }
// }
</style>

